import React from "react";
import { FieldRichTextEditorTemplate } from "themes/common/components";

function FieldRichTextEditor(props) {
    return <FieldRichTextEditorTemplate {...props} />;
}

export default FieldRichTextEditor;
